'use strict';

var validator = require('validator');
var y = require('yup');

function _interopNamespaceCompat(e) {
    if (e && typeof e === 'object' && 'default' in e) return e;
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    }
    n.default = e;
    return Object.freeze(n);
}

var y__namespace = /*#__PURE__*/_interopNamespaceCompat(y);

exports.IBAN_ERROR = void 0;
(function(IBAN_ERROR) {
    IBAN_ERROR["COUNTRY"] = "iban.country";
    IBAN_ERROR["FORMAT"] = "iban.format";
})(exports.IBAN_ERROR || (exports.IBAN_ERROR = {}));
/**
 * Check for valid IBAN (International Bank Account Number).
 */ y__namespace.addMethod(y__namespace.StringSchema, 'iban', function({ countryCode, countryError, formatError } = {}) {
    return this.test(function(value) {
        const { path, createError } = this;
        // Check for localized IBAN
        if (countryCode != null && !value?.toUpperCase().startsWith(countryCode.toUpperCase())) {
            return createError({
                path,
                type: 'iban',
                message: {
                    key: countryError ?? exports.IBAN_ERROR.COUNTRY
                }
            });
        }
        // Check for any other IBAN
        if (value != null && !validator.isIBAN(value)) {
            return createError({
                path,
                type: 'iban',
                message: {
                    key: formatError ?? exports.IBAN_ERROR.FORMAT
                }
            });
        }
        // valid
        return true;
    });
});
//# sourceMappingURL=iban.js.map
